var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarginleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_5970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7222 18.3398L2.59717 18.3398V17.2148H3.53467V16.0898H2.59717V14.9648H3.53467V13.8398H2.59717L2.59717 12.7148H3.53467V11.5898H2.59717V10.4648H3.53467V9.33984H2.59717V8.21484H3.53467V7.08984H2.59717V5.96484H3.53467V4.83984H2.59717L2.59717 3.71484H3.53467V2.58984H2.59717V1.46484H3.53467V0.339844L15.7222 0.339844L15.7222 18.3398ZM4.47217 1.46484L4.47217 17.2148L14.7847 17.2148L14.7847 1.46484L4.47217 1.46484ZM1.65967 18.3398V17.2148H0.722168V18.3398H1.65967ZM2.59717 17.2148V16.0898H1.65967V17.2148H2.59717ZM1.65967 16.0898V14.9648H0.722168V16.0898H1.65967ZM2.59717 14.9648V13.8398H1.65967V14.9648L2.59717 14.9648ZM1.65967 13.8398L1.65967 12.7148H0.722168L0.722168 13.8398H1.65967ZM2.59717 12.7148V11.5898H1.65967V12.7148H2.59717ZM1.65967 11.5898V10.4648H0.722168V11.5898H1.65967ZM2.59717 10.4648V9.33984H1.65967V10.4648H2.59717ZM1.65967 9.33984V8.21484L0.722168 8.21484V9.33984L1.65967 9.33984ZM2.59717 8.21484V7.08984H1.65967V8.21484H2.59717ZM1.65967 7.08984V5.96484L0.722168 5.96484V7.08984L1.65967 7.08984ZM2.59717 5.96484V4.83984H1.65967V5.96484H2.59717ZM1.65967 4.83984L1.65967 3.71484L0.722168 3.71484L0.722168 4.83984L1.65967 4.83984ZM2.59717 3.71484V2.58984H1.65967V3.71484H2.59717ZM1.65967 2.58984V1.46484H0.722168V2.58984L1.65967 2.58984ZM2.59717 1.46484V0.339844H1.65967V1.46484H2.59717Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_5970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "matrix(0 -1 -1 0 15.7222 18.3398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginleft);
export default __webpack_public_path__ + "static/media/marginleft.4b152b917665df0c1e85fc7d820bc4b1.svg";
export { ForwardRef as ReactComponent };